import { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader } from "reactstrap";
import Select from "src/components/Select/Select";
import useLazyFetch from "src/hooks/useLazyFetch";
import {
  CAMERA_CAPTURE,
  CAMERA_CAPTURED_HEX,
  CAMERA_READ,
} from "src/redux/config/links";

const CameraCapture = () => {
  const [oneTime, setOneTime] = useState(true);
  const [loadingCapture, setLoadingCapture] = useState(false);
  const [loadingRead, setLoadingRead] = useState(false);
  const [currentRead, setCurrentRead] = useState(0);
  const [changeOption, setChangeOption] = useState<{
    label: string;
    value: string;
  } | null>({ label: "Front", value: "front" });
  const [onGetData, { loading, data: camData }] = useLazyFetch({
    url: CAMERA_CAPTURED_HEX,
    method: "POST",
  });
  const [onCapture] = useLazyFetch({
    url: CAMERA_CAPTURE,
    method: "POST",
  });
  const [onRead] = useLazyFetch({
    url: CAMERA_READ,
    method: "POST",
    type: "json",
  });

  const onReadAll = (totalPage: number, page = 1, cb: () => void) => {
    setCurrentRead(page);
    onRead(
      {
        body: {
          options: changeOption?.value,
          page,
        },
      },
      () => {
        if (page + 1 <= totalPage) {
          setTimeout(() => {
            onReadAll(totalPage, page + 1, cb);
          }, 5000);
        } else {
          cb();
        }
      }
    );
  };

  const hexToBase64 = (hex: string) => {
    const cleanHex = hex.replace(/[^A-Fa-f0-9]/g, "");

    const bytes = new Uint8Array(
      (cleanHex.match(/.{1,2}/g) ?? []).map((byte) => parseInt(byte, 16))
    );

    // Convert bytes → string
    let binary = "";
    bytes.forEach((b) => (binary += String.fromCharCode(b)));

    return btoa(binary); // Base64
  };

  useEffect(() => {
    if (oneTime) {
      setOneTime(false);

      onGetData({}, (res, err) => {
        if (!!!err && !!res) {
          setCurrentRead(res.data.result.sorted.length);
          setChangeOption(
            [
              { label: "Front", value: "front" },
              { label: "Rear", value: "rear" },
            ].find(
              (item) => item.value === res.data.result.captured.data.options
            ) ?? null
          );
        }
      });
    }
  }, [onGetData, oneTime, setCurrentRead]);

  return (
    <>
      <Card>
        <CardHeader>Camera</CardHeader>
        <CardBody>
          <Select
            name={"Option"}
            onChange={(value) => {
              setChangeOption(value);
            }}
            option={[
              { label: "Front", value: "front" },
              { label: "Rear", value: "rear" },
            ]}
            value={changeOption}
            page={{ of: 1 }}
            totalPage={1}
            onPage={() => null}
            onKeypress={() => null}
            loading={false}
          />
          <Button
            type="button"
            color="primary"
            disabled={loading || loadingCapture || loadingRead}
            onClick={() => {
              if (
                !!camData &&
                !!camData.result.captured &&
                currentRead - camData.result.captured.data.pages !== 0
              ) {
                setLoadingRead(true);
                onReadAll(
                  camData.result.captured.data.pages,
                  currentRead,
                  () => {
                    setTimeout(() => {
                      setLoadingRead(false);
                      onGetData({});
                    }, 5000);
                  }
                );
              } else {
                setLoadingCapture(true);
                onCapture(
                  {
                    body: {
                      options: changeOption?.value,
                    },
                  },
                  () => {
                    setTimeout(() => {
                      setLoadingCapture(false);
                      onGetData({}, (res, err) => {
                        if (!!!err) {
                          if (!!res?.data.result.captured) {
                            setLoadingRead(true);
                            setTimeout(() => {
                              onReadAll(
                                res?.data.result.captured.data.pages,
                                1,
                                () => {
                                  setTimeout(() => {
                                    setLoadingRead(false);
                                    onGetData({});
                                  }, 5000);
                                }
                              );
                            }, 5000);
                          }
                        }
                      });
                    }, 5000);
                  }
                );
              }
            }}
          >
            {!!camData && !!camData.result.captured
              ? camData.result.captured.data.pages !== currentRead
                ? "Continue"
                : "Capture"
              : "Capture"}
          </Button>

          {!!loading ? "Loading..." : null}
          {!!loadingCapture ? "Capturing..." : null}
          {!!loadingRead ? (
            <>
              Reading{" "}
              {!!camData && !!camData.result.captured ? (
                <>
                  ({currentRead} / {camData.result.captured.data.pages})
                </>
              ) : null}
              ...
            </>
          ) : null}
          <div>
            {!!camData && !!camData.result.hexcode ? (
              <img
                src={`data:image/jpeg;base64,${hexToBase64(
                  camData.result.hexcode
                )}`}
              />
            ) : null}
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default CameraCapture;
